module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgements#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part001#pt001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Five-Part Advent Series for the "), _c('i', [_vm._v("Christian Century")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suffering and Hope: An Advent Series for Grace Church, New York City, 1987")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expectation and Hope: Advent in the Writings of Karl Barth; A Three-Part Reflection for Grace Church in New York City, Advent 1986")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Something Evil This Way Comes”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting and Hastening the Kingdom Yet to Come (Pre-Advent)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting and Hastening")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of the Ice Age")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whispers in Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s in Those Lamps?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hope of Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Voice of the Son of Man")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-012"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Universal Grip of the Enemy (Pre-Advent)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When God Is Silent")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Enemy Outvoted")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Call to Resistance")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Righteous Deeds Like Filthy Rags")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017#ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Line Runs through Each Person")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice and the Final Judgment (Pre-Advent)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019#ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Consuming Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020#ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Save Us in the Time of Trial, and Deliver Us from the Evil One")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021#ch021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loving the Dreadful Day of Judgment")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022#ch022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great "), _c('i', [_vm._v("BUT")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter023#ch023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Works and Words: Signs of the End")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter024#ch024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Apocalyptic War (The Feast of Saint Michael)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-025"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter025#ch025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver and Gold on the Last Day")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter026#ch026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Army of Saint Michael")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter027#ch027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Apocalyptic War")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter028#ch028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Is Your Battle Station?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-029"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter029#ch029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Coming of the Lord (Last Sunday of the Church Year: The Feast of Christ the King)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-030"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter030#ch030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("King of Kings and Lord of Lords")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-031"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter031#ch031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Will Be There")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-032"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter032#ch032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When the Man Comes Around")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-033"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter033#ch033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Are Those Wailing People?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-034"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter034#ch034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advent Begins in the Dark (Advent I)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-035"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter035#ch035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advent Begins in the Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-036"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter036#ch036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The God Who Hides Himself")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-037"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter037#ch037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Doorkeeper")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-038"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter038#ch038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Advent Life for Nonheroic People")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-039"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter039#ch039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Armor of Light (Advent II)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-040"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter040#ch040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Location with John the Baptist")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-041"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter041#ch041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advent at Ground Zero")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-042"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter042#ch042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Cut-and-Fill Operation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-043"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter043#ch043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Axe at the Root of the Trees")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-044"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter044#ch044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Armor of Light")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-045"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter045#ch045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bearing Witness on the Brink (Advent III)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-046"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter046#ch046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advent on the Brink of War")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-047"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter047#ch047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bottom of the Night")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-048"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter048#ch048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grace in a Violent World")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-049"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter049#ch049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Better Bet")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-050"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter050#ch050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beyond the Valley of Ashes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-051"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter051#ch051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting for the Dayspring")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-052"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter052#ch052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Glory of Lebanon")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-053"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter053#ch053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sign of Immanu-el")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-054"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter054#ch054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("King of the Last Things (Advent IV)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-055"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter055#ch055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-056"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter056#ch056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God on the Move")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-057"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter057#ch057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Bleak Midwinter")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-058"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter058#ch058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Somewhere beyond Mindless Fluffland")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-059"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter059#ch059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Magical Reversal")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part003#pt003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERVICE OF")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESSONS AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AROLS FOR")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DVENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-060"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter060#ch060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great “O” Antiphons of Advent")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Biblical Passages")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0